export const VALIDATION_ERROR_MESSAGE =
   'Please enter or correct all required fields.';
export const TEXT_MAX_LENGTH = 1000;
export const TEXT_MAX_LENGTH_SUSPENSION = 50;
